import { ComponentChildren, ComponentProps } from 'preact';
import { Divider } from '../UNSAFE_Divider';
import { MobileDropdown } from './MobileDropdown';
import { selectMobileDropdownStyles } from './themes/selectMobileDropdownStyles.css';

type MobileDropdownProps = ComponentProps<typeof MobileDropdown>;
type PassThroughMobileDropdownProps = Pick<MobileDropdownProps, 'id' | 'isOpen'>;

type Props = PassThroughMobileDropdownProps & {
  /**
   * The main dropdown content
   */
  children?: ComponentChildren;

  /**
   * The components to be placed in the end of the dropdown
   */
  footer?: ComponentChildren;

  /**
   * The components to be placed in the beginning of the dropdown
   */
  header?: ComponentChildren;
};

export function SelectMobileDropdown({ children, footer, header, id, isOpen }: Props) {
  return (
    <MobileDropdown id={id} isOpen={isOpen}>
      {header}
      <Divider />
      {/* TODO: Add overflow support to View and use it here */}
      {/*  */}
      <div class={selectMobileDropdownStyles.content}>{children}</div>
      <Divider />
      {footer}
    </MobileDropdown>
  );
}
